<template>
    <div class="expired-licence-page">
        <ExpiredLicenceAlert />
    </div>
</template>

<script>
import ExpiredLicenceAlert from "./dialogs/ExpiredLicenceAlert.vue";

export default {
    name: "ExpiredLicence",
    components: {
        ExpiredLicenceAlert
    },
    created() {
        this.$store.commit('SET_LAYOUT', 'nav-layout');
    }
}
</script>

<style scoped>
.expired-licence-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 52px);
    width: 100%;
    background-image: url('/assets/img/theme/Blur%20dashboard.png');
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
